import styled from 'styled-components';

export const StyledGuardianDetailsModalOpenButton = styled.div`
   min-width: 215px;
   margin-top: 26px;
`;
StyledGuardianDetailsModalOpenButton.displayName = 'StyledGuardianDetailsModalOpenButton';
